import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DateInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedReq = this.modifyRequest(req);
    return next.handle(modifiedReq);
  }

  private modifyRequest(req: HttpRequest<any>): HttpRequest<any> {
    const params = req.params;
    const startedAtParam = params.get('by_period[started_at]');
    const endedAtParam = params.get('by_period[ended_at]');

    if (startedAtParam !== null && endedAtParam !== null) {
      const startDate = new Date(startedAtParam);
      const endDate = new Date(endedAtParam);

      if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
        params.set('by_period[started_at]', startDate.toISOString());
        params.set('by_period[ended_at]', endDate.toISOString());
      } else {
        params.delete('by_period[started_at]');
        params.delete('by_period[ended_at]');
      }
    }

    return req.clone({ params });
  }
}
